/* 魯肅（字子敬） */
import { defineHero, hook, S } from '../define.ts';

export default defineHero({
  id: 'lusu', name: '魯肅', sub: '字子敬', faction: 'wu', role: '輔助', weapon: 'sword',
  look: { ranged: true, head: 'guan', robe: true, beard: 'goatee', fx: '#9be07a', c: { cloth: '#5a7a4a', sleeve: '#5a7a4a', armor: '#e9c46a' } },
  skills: [
    ['指囷相贈', 'heal', '分糧給友軍，治療 {100/160/220/280} 生命。'],
    ['調停', 'shield', '自己得到吸收 {100/160/220/280} 傷害的護盾 3 秒（身旁一名友將得到六成）；周圍敵人 {1/1.25/1.5/1.75} 秒內不能攻擊。'],
    ['聯劉抗曹', 'passive', '600 內的友軍防禦 +{2/3/4/5}；附近有蜀將時再多一半。', { pv: {}, sig: 'alliance', armor: [2, 3, 4, 5] }],
    ['榻上策', 'command', '10 秒內 700 內的友軍攻擊 +{10/15/20}%、移速 +{5/8/10}%。', { x: { k: 'buff', to: 'near', r: 700, atkP: [10, 15, 20], ms: [5, 8, 10], dur: 10 }, aim: S(700), glyph: '盟' }],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 聯劉抗曹：附近友軍加防禦，有蜀將在附近時加倍
    hook('tick', 20, function (u, dt) {
      const g = u.sg;
      if (g && g.alliance && (u.allyT = (u.allyT || 0) - dt) <= 0) {
        u.allyT = 0.5;
        const near = this.alliesNear(u, 600), shu = near.some((h) => h.kind === 'hero' && h.spec.faction === 'shu');
        const arm = g.alliance.v('armor') * (shu ? 1.5 : 1);
        near.forEach((t) => this.addBuff(t, { id: 'alliance:' + u.id, t: 0.8, armor: arm }));
      }
    }),
  ],
});
